import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

export const LangSwitcherWrapper = styled.div<{ mode: ThemeMode }>`
  box-sizing: border-box;
  .MuiButtonBase-root {
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
    min-width: auto;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 18px;
      padding: 4px 8px;
    }

    @media (max-width: 480px) {
      font-size: 13px;
      padding: 4px 6px;
    }

    svg {
      fill: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
    }
  }
  .MuiButton-endIcon {
    margin-left: 4px;
    margin-right: 0;
    & > *:first-of-type {
      font-size: 13px;

      @media (max-width: 480px) {
        font-size: 11px;
      }
    }
  }
`;
